// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1RoleSchema = z.object({
  id: z.number().int().describe("Unique identifier for the role"),
  name: z.coerce.string().describe("Internal role name (admin, manager, employee, team_lead)"),
  display_name: z.coerce.string().describe("Human-readable role name"),
  description: z.coerce.string().describe("Description of the role permissions and capabilities"),
  scopes: z.array(z.object({
    name: z.coerce.string(),
    display_name: z.coerce.string(),
    description: z.coerce.string(),
    default: z.boolean(),
    options: z.array(z.boolean()),
  })).describe("Configurable permission scopes for this role"),
  default: z.boolean().describe("Whether this is the default role for new users"),
  allowed_to_invite: z.boolean().describe("Whether users with this role can invite new members"),
});
